import { apiClient } from './apiClient';
import { CreateExpenseRequest, Expense, ExpenseStatus, UpdateExpenseRequest } from '../types/expense';

export const expenseService = {
  getPaginated: async (
    companyId: string,
    params: URLSearchParams
  ): Promise<any> => {
    const response = await apiClient.get(`/companies/${companyId}/expenses/paginated?${params}`);
    return response.data;
  },

  getById: async (companyId: string, expenseId: string): Promise<Expense> => {
    const response = await apiClient.get(`/companies/${companyId}/expenses/${expenseId}`);
    return response.data;
  },

  create: async (companyId: string, payload: CreateExpenseRequest): Promise<Expense> => {
    const response = await apiClient.post(`/companies/${companyId}/expenses`, payload);
    return response.data;
  },

  update: async (companyId: string, expenseId: string, payload: UpdateExpenseRequest): Promise<Expense> => {
    const response = await apiClient.put(`/companies/${companyId}/expenses/${expenseId}`, payload);
    return response.data;
  },

  delete: async (companyId: string, expenseId: string): Promise<void> => {
    await apiClient.delete(`/companies/${companyId}/expenses/${expenseId}`);
  },

  uploadFile: async (companyId: string, expenseId: string, file: File): Promise<Expense> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(`/companies/${companyId}/expenses/${expenseId}/file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  downloadFile: async (companyId: string, expenseId: string): Promise<Blob> => {
    const response = await apiClient.get(`/companies/${companyId}/expenses/${expenseId}/file`, {
      responseType: 'blob'
    });
    return response.data;
  },

  deleteFile: async (companyId: string, expenseId: string): Promise<Expense> => {
    const response = await apiClient.delete(`/companies/${companyId}/expenses/${expenseId}/file`);
    return response.data;
  }
};

export const ExpenseStatusLabels: Record<ExpenseStatus, string> = {
  [ExpenseStatus.NEW]: 'Новый',
  [ExpenseStatus.APPROVED]: 'Подтвержден',
  [ExpenseStatus.PAID]: 'Оплачен',
  [ExpenseStatus.CANCELLED]: 'Отменен'
};

